"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_ReflectiveCurseEffectHandler = exports.Passive_ReflectiveCurseEffectArgs = void 0;
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class Passive_ReflectiveCurseEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Passive_ReflectiveCurse;
        this.__typeName = "Passive_ReflectiveCurse";
        this.name = "Reflective Curse";
        this.harmful = true;
    }
}
exports.Passive_ReflectiveCurseEffectArgs = Passive_ReflectiveCurseEffectArgs;
let Passive_ReflectiveCurseEffectHandler = class Passive_ReflectiveCurseEffectHandler {
    apply(sequence, container, state) {
        state.meta.ehId = container.registerEventHandlerScript(state.targetId, EventType_1.EventType.EffectApplied, Schedule_1.Schedule.Unlimited, "Effect_Passive_ReflectiveCurse_OnEffectApplied", {});
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.ehId);
    }
};
Passive_ReflectiveCurseEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Passive_ReflectiveCurse)
], Passive_ReflectiveCurseEffectHandler);
exports.Passive_ReflectiveCurseEffectHandler = Passive_ReflectiveCurseEffectHandler;
